import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
dayjs.extend(duration)

/**
 * Compact relative duration showing at most the two most-significant units,
 * e.g. "1y 2mo", "3mo 5d", "5d", "2h", "10min". Direction-agnostic (returns
 * the magnitude only) — callers add any "in …" / "… ago" framing.
 */
export const formatCompactTimeDiff = (timestampString: string) => {
  const diff = dayjs.duration(Math.abs(dayjs(timestampString).diff(dayjs())))

  const units: [number, string][] = [
    [diff.years(), "y"],
    [diff.months(), "mo"],
    [diff.days(), "d"],
    [diff.hours(), "h"],
    [diff.minutes(), "min"]
  ]

  const parts = units
    .filter(([value]) => value > 0)
    .slice(0, 2)
    .map(([value, unit]) => `${value}${unit}`)

  return parts.join(" ") || "<1min"
}

export const formatTimeDiff = (timestampString: string) => {
  const now = dayjs()
  const target = dayjs(timestampString)
  const diff = target.diff(now)

  if (diff > 0) {
    // Time until
    const duration = dayjs.duration(diff)
    const years = duration.years()
    const months = duration.months()
    const days = duration.days()
    const hours = duration.hours()
    const minutes = duration.minutes()

    let formattedTime = ""
    if (years > 0) {
      formattedTime += `${years} year${years > 1 ? "s" : ""}`
    }
    if (months > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${months} month${months > 1 ? "s" : ""}`
    }
    if (days > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${days} day${days > 1 ? "s" : ""}`
    }
    if (hours > 0 && years === 0 && months === 0 && days === 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${minutes > 1 ? "s" : ""}`
    }
    return formattedTime || "less than a minute"
  } else {
    // Time since
    const duration = dayjs.duration(-diff)
    const years = duration.years()
    const months = duration.months()
    const days = duration.days()
    const hours = duration.hours()
    const minutes = duration.minutes()

    let formattedTime = ""
    if (years > 0) {
      formattedTime += `${years} year${years > 1 ? "s" : ""}`
    }
    if (months > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${months} month${months > 1 ? "s" : ""}`
    }
    if (days > 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${days} day${days > 1 ? "s" : ""}`
    }
    if (hours > 0 && years === 0 && months === 0 && days === 0) {
      if (formattedTime) {
        formattedTime += ", "
      }
      formattedTime += `${hours} hour${hours > 1 ? "s" : ""}, ${minutes} minute${minutes > 1 ? "s" : ""}`
    }
    return formattedTime || "less than a minute"
  }
}
